import { render, staticRenderFns } from "./MemberInfoBasic.vue?vue&type=template&id=1a57c899&scoped=true&"
import script from "./MemberInfoBasic.vue?vue&type=script&lang=js&"
export * from "./MemberInfoBasic.vue?vue&type=script&lang=js&"
import style0 from "./MemberInfoBasic.vue?vue&type=style&index=0&id=1a57c899&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a57c899",
  null
  
)

export default component.exports